import React, { useEffect } from "react";

export function patchFramerMotion() {
  if (typeof window === "undefined") return;

  const originalConsoleError = console.error;

  // Suppress specific Framer Motion / React warnings without touching RAF.
  // Wrapping requestAnimationFrame in try-catch kills framer-motion's animation
  // driver: its frame loop reschedules itself at the END of each frame, so a
  // caught error during unmount cleanup prevents rescheduling and freezes all
  // subsequent framer-motion animations (e.g. carousel dots stuck at opacity 0).
  console.error = (...args) => {
    const message = args[0] || "";
    if (typeof message === "string") {
      if (message.includes('Each child in a list should have a unique "key" prop')) return;
      if (message.includes("NaNpx is not an animatable value")) return;
      if (message.includes("Node cannot be found")) return;
    }
    originalConsoleError(...args);
  };

  return () => {
    console.error = originalConsoleError;
  };
}

export function AnimationErrorHandler({ children }) {
  useEffect(() => {
    const cleanup = patchFramerMotion();
    return cleanup;
  }, []);

  return <>{children}</>;
}
